/**
 * Quem emite a mensalidade do posto.
 *
 * `SUBSCRIPTION` é o histórico: a assinatura do Gestão Click gera o recebimento e carimba a
 * competência com a data do clique. `PONTUAX` é o worker mensal, que usa o mês de referência.
 *
 * Os dois ligados ao mesmo tempo cobram o posto duas vezes de verdade.
 */
export enum BillingSource {
  SUBSCRIPTION = 'subscription',
  PONTUAX = 'pontuax',
}
